export const NEW_CARS_FLOW_LEVEL_COOKIE = 'newCarsFlowLevel';

// Higher value = higher in the funnel. Hero hides on pages below the highest visited.
export const NEW_CARS_FLOW_LEVELS = {
  parentModel: 0,
  make: 1,
  new: 2
} as const;

export type NewCarsFlowLevel =
  (typeof NEW_CARS_FLOW_LEVELS)[keyof typeof NEW_CARS_FLOW_LEVELS];

export function parseFlowLevel(
  raw: string | undefined
): NewCarsFlowLevel | null {
  if (raw === undefined) return null;
  const parsed = Number(raw);

  return parsed === 0 || parsed === 1 || parsed === 2 ? parsed : null;
}

export function shouldShowHero(
  pageLevel: NewCarsFlowLevel,
  highestLevelVisited: NewCarsFlowLevel | null
): boolean {
  return highestLevelVisited === null || pageLevel >= highestLevelVisited;
}
